"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SETUP_ROLES = void 0;
var SETUP_ROLES;
(function (SETUP_ROLES) {
    SETUP_ROLES["CREATE_LOCATION"] = "create-location";
    SETUP_ROLES["MODIFY_LOCATION"] = "modify-location";
})(SETUP_ROLES = exports.SETUP_ROLES || (exports.SETUP_ROLES = {}));
//# sourceMappingURL=setup.roles.js.map